export default __webpack_public_path__ + "static/waldfred-0cd074b96b12229ab5e5b58b0b59b87a.png";